import React, { useMemo } from "react";
import Field from "./Field";
import FieldControl from "./FieldControl";

/**
 * Form internal component for rendering a column.
 */
var FormColumn = function FormColumn(_ref) {
  var column = _ref.column,
      displayForm = _ref.displayForm,
      themeUuid = _ref.themeUuid,
      handleField = _ref.handleField,
      formState = _ref.formState,
      handleColumnChange = _ref.handleColumnChange,
      handleDictionaryItemSelect = _ref.handleDictionaryItemSelect,
      handleValidityChange = _ref.handleValidityChange;

  var _ref2 = formState[column.name] || {},
      value = _ref2.value,
      dirty = _ref2.dirty,
      valid = _ref2.valid;

  var label = column.label,
      disabled = column.disabled,
      readOnly = column.readOnly,
      name = column.name,
      required = column.required,
      type = column.type,
      config = column.config,
      items = column.items,
      visible = column.visible,
      isDictionary = column.isDictionary,
      dictionaryConfig = column.dictionaryConfig,
      srid = column.srid,
      geometryType = column.geometryType;


  var fieldProps = useMemo(function () {
    return {
      name: name,
      value: value,
      config: config,
      dirty: dirty,
      valid: valid,
      label: label,
      disabled: disabled,
      // Fields may optionally change their representation when this is set.
      // If they don't, they are expected to handle readOnly properly.
      displayForm: displayForm,
      readOnly: readOnly || displayForm,
      required: required,
      type: type || "unknown",
      onValueChange: function onValueChange(value) {
        handleColumnChange(name, value);
      },
      onDictionaryItemSelect: function onDictionaryItemSelect(item, dictionaryConfig) {
        handleDictionaryItemSelect(name, item, dictionaryConfig);
      },
      onValidityChange: function onValidityChange(valid) {
        handleValidityChange(name, valid);
      },
      themeUuid: themeUuid,
      items: items || null,
      isDictionary: isDictionary,
      dictionaryConfig: dictionaryConfig,
      srid: srid,
      geometryType: geometryType
    };
  }, [name, value, config, dirty, valid, label, disabled, displayForm, readOnly, required, type, handleColumnChange, handleDictionaryItemSelect, handleValidityChange, themeUuid, items, isDictionary, dictionaryConfig, srid, geometryType]);

  var override = useMemo(function () {
    return handleField(fieldProps);
  }, [fieldProps]);

  if (!visible & type !== "geometryField") return false;

  if (config && config.dependency) {
    var _config$dependency = config.dependency,
        dependencyFields = _config$dependency.field,
        dependencyValues = _config$dependency.value;


    if (!Array.isArray(dependencyFields)) {
      dependencyFields = [dependencyFields];
    }

    if (dependencyValues == null) {
      dependencyValues = [true];
    } else if (!Array.isArray(dependencyFields)) {
      dependencyFields = [dependencyFields];
    }

    var dependencyOk = dependencyFields.some(function (f) {
      return dependencyValues.some(function (v) {
        return formState[f] && formState[f].value === v;
      });
    });
    if (!dependencyOk) return false;
  }

  if (override === false) return null;
  if (override && override !== true) return override;

  switch (type) {
    case "geometryField":
      return null;
    default:
      break;
  }

  return React.createElement(
    Field,
    {
      key: name,
      className: "dt-field-" + (type || "unknown"),
      label: label,
      required: required,
      inline: displayForm
    },
    React.createElement(FieldControl, fieldProps)
  );
};

export default FormColumn;